<form [formGroup]="loanProductAccountingForm">

  <div fxLayout="row wrap" fxLayoutGap="2%" fxLayout.lt-md="column">

    <mat-radio-group fxFlex="98%" fxLayout="row" fxLayoutGap="5%" fxLayout.lt-md="column" formControlName="accountingRule">
      <mat-radio-button *ngFor="let accountingRule of accountingRuleData; let i =  index" [value]="i+1">
        {{ accountingRule }}
      </mat-radio-button>
    </mat-radio-group>

    <mat-divider fxFlex="98%"></mat-divider>

    <div *ngIf="loanProductAccountingForm.value.accountingRule >= 2 && loanProductAccountingForm.value.accountingRule <= 4" fxFlexFill fxLayout="row wrap" fxLayoutGap="2%" fxLayout.lt-md="column">

      <h4 fxFlex="98%" class="mat-h4">Assets / Liability</h4>

      <mat-form-field fxFlex="48%">
        <mat-label>Fund source</mat-label>
        <mat-select formControlName="fundSourceAccountId" required>
          <mat-option *ngFor="let assetAndLiabilityAccount of assetAndLiabilityAccountData" [value]="assetAndLiabilityAccount.id">
            ({{ assetAndLiabilityAccount.glCode }}) {{ assetAndLiabilityAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Fund source is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="48%">
        <mat-label>Subvention Payable</mat-label>
        <mat-select formControlName="subventionPayableAccountId" required>
          <mat-option *ngFor="let liabilityAccount of liabilityAccountData" [value]="liabilityAccount.id">
            ({{ liabilityAccount.glCode }}) {{ liabilityAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Subvention Payable is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="48%">
        <mat-label>Rebate Payable</mat-label>
        <mat-select formControlName="rebatePayableAccountId" required>
          <mat-option *ngFor="let liabilityAccount of liabilityAccountData" [value]="liabilityAccount.id">
            ({{ liabilityAccount.glCode }}) {{ liabilityAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Rebate Payable is <strong>required</strong>
        </mat-error>
      </mat-form-field>


      <h4 fxFlex="98%" class="mat-h4">Assets</h4>

      <mat-form-field fxFlex="48%">
        <mat-label>Loan portfolio</mat-label>
        <mat-select formControlName="loanPortfolioAccountId" required>
          <mat-option *ngFor="let assetAccount of assetAccountData" [value]="assetAccount.id">
            ({{ assetAccount.glCode }}) {{ assetAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Loan portfolio is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <div *ngIf="loanProductAccountingForm.value.accountingRule === 3 || loanProductAccountingForm.value.accountingRule === 4" fxFlexFill fxLayout="row wrap" fxLayoutGap="2%" fxLayout.lt-md="column">

        <mat-form-field fxFlex="48%">
          <mat-label>Interest Receivable</mat-label>
          <mat-select formControlName="receivableInterestAccountId" required>
            <mat-option *ngFor="let assetAccount of assetAccountData" [value]="assetAccount.id">
              ({{ assetAccount.glCode }}) {{ assetAccount.name }}
            </mat-option>
          </mat-select>
          <mat-error>
            Interest Receivable is <strong>required</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="48%">
          <mat-label>Fees Receivable</mat-label>
          <mat-select formControlName="receivableFeeAccountId" required>
            <mat-option *ngFor="let assetAccount of assetAccountData" [value]="assetAccount.id">
              ({{ assetAccount.glCode }}) {{ assetAccount.name }}
            </mat-option>
          </mat-select>
          <mat-error>
            Fees Receivable is <strong>required</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="48%">
          <mat-label>Penalties Receivable</mat-label>
          <mat-select formControlName="receivablePenaltyAccountId" required>
            <mat-option *ngFor="let assetAccount of assetAccountData" [value]="assetAccount.id">
              ({{ assetAccount.glCode }}) {{ assetAccount.name }}
            </mat-option>
          </mat-select>
          <mat-error>
            Penalties Receivable is <strong>required</strong>
          </mat-error>
        </mat-form-field>

      </div>

      <mat-form-field fxFlex="48%">
        <mat-label>Transfer in suspense</mat-label>
        <mat-select formControlName="transfersInSuspenseAccountId" required>
          <mat-option *ngFor="let assetAccount of assetAccountData" [value]="assetAccount.id">
            ({{ assetAccount.glCode }}) {{ assetAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Transfer in suspense is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-divider fxFlex="98%"></mat-divider>

      <h4 fxFlex="98%" class="mat-h4">Income</h4>

      <mat-form-field fxFlex="48%">
        <mat-label>Income from Interest</mat-label>
        <mat-select formControlName="interestOnLoanAccountId" required>
          <mat-option *ngFor="let incomeAccount of incomeAccountData" [value]="incomeAccount.id">
            ({{ incomeAccount.glCode }}) {{ incomeAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Income from Interest is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="48%">
        <mat-label>Income from fees</mat-label>
        <mat-select formControlName="incomeFromFeeAccountId" required>
          <mat-option *ngFor="let incomeAccount of incomeAccountData" [value]="incomeAccount.id">
            ({{ incomeAccount.glCode }}) {{ incomeAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Income from fees is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="48%">
        <mat-label>Income from penalties</mat-label>
        <mat-select formControlName="incomeFromPenaltyAccountId" required>
          <mat-option *ngFor="let incomeAccount of incomeAccountData" [value]="incomeAccount.id">
            ({{ incomeAccount.glCode }}) {{ incomeAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Income from penalties is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="48%">
        <mat-label>Income from Recovery Repayments</mat-label>
        <mat-select formControlName="incomeFromRecoveryAccountId" required>
          <mat-option *ngFor="let incomeAccount of incomeAccountData" [value]="incomeAccount.id">
            ({{ incomeAccount.glCode }}) {{ incomeAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Income from Recovery Repayments is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-divider fxFlex="98%"></mat-divider>

      <h4 fxFlex="98%" class="mat-h4">Expenses</h4>

      <mat-form-field fxFlex="48%">
        <mat-label>Principal written off</mat-label>
        <mat-select formControlName="writeOffAccountId" required>
          <mat-option *ngFor="let expenseAccount of expenseAccountData" [value]="expenseAccount.id">
            ({{ expenseAccount.glCode }}) {{ expenseAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Principal written off is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="48%">
        <mat-label>Goodwill credit</mat-label>
        <mat-select formControlName="goodwillCreditAccountId" required>
          <mat-option *ngFor="let expenseAccount of expenseAccountData" [value]="expenseAccount.id">
            ({{ expenseAccount.glCode }}) {{ expenseAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Goodwill credit is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="48%">
        <mat-label>Subvention on loan</mat-label>
        <mat-select formControlName="subventionOnLoanAccountId" required>
          <mat-option *ngFor="let expenseAccount of expenseAccountData" [value]="expenseAccount.id">
            ({{ expenseAccount.glCode }}) {{ expenseAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Subvention on loan is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="48%">
        <mat-label>Subvention Provisioning</mat-label>
        <mat-select formControlName="subventionProvisioningAccountId" required>
          <mat-option *ngFor="let expenseAccount of expenseAccountData" [value]="expenseAccount.id">
            ({{ expenseAccount.glCode }}) {{ expenseAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Subvention Provisioning is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="48%">
        <mat-label>Rebate on loan</mat-label>
        <mat-select formControlName="rebateOnLoanAccountId" required>
          <mat-option *ngFor="let expenseAccount of expenseAccountData" [value]="expenseAccount.id">
            ({{ expenseAccount.glCode }}) {{ expenseAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Rebate on loan is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="48%">
        <mat-label>Rebate Provisioning</mat-label>
        <mat-select formControlName="rebateProvisioningAccountId" required>
          <mat-option *ngFor="let expenseAccount of expenseAccountData" [value]="expenseAccount.id">
            ({{ expenseAccount.glCode }}) {{ expenseAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Rebate Provisioning is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="48%">
        <mat-label>Interest written off</mat-label>
        <mat-select formControlName="interestWriteOffAccountId" required>
          <mat-option *ngFor="let expenseAccount of expenseAccountData" [value]="expenseAccount.id">
            ({{ expenseAccount.glCode }}) {{ expenseAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Interest written off is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="48%">
         <mat-label>Charge written off</mat-label>
         <mat-select formControlName="chargeWriteOffAccountId" required>
           <mat-option *ngFor="let expenseAccount of expenseAccountData" [value]="expenseAccount.id">
                    ({{ expenseAccount.glCode }}) {{ expenseAccount.name }}
           </mat-option>
         </mat-select>
         <mat-error>
           Charge written off is <strong>required</strong>
         </mat-error>
      </mat-form-field>

      <mat-divider fxFlex="98%"></mat-divider>

      <h4 fxFlex="98%" class="mat-h4">Liabilities</h4>

      <mat-form-field fxFlex="48%">
        <mat-label>Over payment liability</mat-label>
        <mat-select formControlName="overpaymentLiabilityAccountId" required>
          <mat-option *ngFor="let liabilityAccount of liabilityAccountData" [value]="liabilityAccount.id">
            ({{ liabilityAccount.glCode }}) {{ liabilityAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Over payment liability is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="48%">
        <mat-label>Probable Subvention</mat-label>
        <mat-select formControlName="probableSubventionAccountId" required>
          <mat-option *ngFor="let liabilityAccount of liabilityAccountData" [value]="liabilityAccount.id">
            ({{ liabilityAccount.glCode }}) {{ liabilityAccount.name }}
          </mat-option>
        </mat-select>
        <mat-error>
          Probable Subvention is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-divider fxFlex="98%"></mat-divider>

      <h3 fxFlex="53%" class="mat-h3">Advanced Accounting Rules</h3>

      <mat-checkbox fxFlex="15%" formControlName="advancedAccountingRules"></mat-checkbox>

      <div *ngIf="loanProductAccountingForm.value.advancedAccountingRules" fxFlexFill fxLayout="row wrap" fxLayoutGap="2%" fxLayout.lt-md="column">

        <h4 fxFlex="33%" class="mat-h4">Configure Fund Sources for Payment Channels</h4>

        <div fxFlex="63%">
          <button type="button" mat-raised-button color="primary" (click)="add('PaymentFundSource', paymentChannelToFundSourceMappings)">
            <fa-icon icon="plus" class="m-r-10"></fa-icon>
            Add
          </button>
        </div>

        <table fxFlex="98%" class="mat-elevation-z1" mat-table [dataSource]="paymentChannelToFundSourceMappings.value" *ngIf="paymentChannelToFundSourceMappings.value.length !== 0">

          <ng-container matColumnDef="paymentTypeId">
            <th mat-header-cell *matHeaderCellDef> Payment Type </th>
            <td mat-cell *matCellDef="let paymentFundSource">
              {{ paymentFundSource.paymentTypeId | find:paymentTypeData:'id':'name' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="fundSourceAccountId">
            <th mat-header-cell *matHeaderCellDef> Fund Source </th>
            <td mat-cell *matCellDef="let paymentFundSource">
              {{ paymentFundSource.fundSourceAccountId | find:assetAccountData:'id':'name' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let paymentFundSource; let i = index">
              <button mat-icon-button color="primary" (click)="edit('PaymentFundSource', paymentChannelToFundSourceMappings, i)">
                <fa-icon icon="edit"></fa-icon>
              </button>
              <button mat-icon-button color="warn" (click)="delete(paymentChannelToFundSourceMappings, i)">
                <fa-icon icon="trash"></fa-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="paymentFundSourceDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: paymentFundSourceDisplayedColumns;"></tr>

        </table>

        <h4 fxFlex="33%" class="mat-h4">Map Fees to Specific Income Accounts</h4>

        <div fxFlex="63%">
          <button type="button" mat-raised-button color="primary" (click)="add('FeesIncome', feeToIncomeAccountMappings)">
            <fa-icon icon="plus" class="m-r-10"></fa-icon>
            Add
          </button>
        </div>

        <table fxFlex="98%" class="mat-elevation-z1" mat-table [dataSource]="feeToIncomeAccountMappings.value" *ngIf="feeToIncomeAccountMappings.value.length !== 0">

          <ng-container matColumnDef="chargeId">
            <th mat-header-cell *matHeaderCellDef> Fees </th>
            <td mat-cell *matCellDef="let feesIncome">
              {{ (feesIncome.chargeId | find:chargeData:'id':'name') || "❗️⚠️💀INACTIVE CHARGE❗️⚠️💀" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="assetAccountId">
            <th mat-header-cell *matHeaderCellDef> Asset Account </th>
            <td mat-cell *matCellDef="let feesIncome">
              {{ feesIncome.assetAccountId | find:assetAccountData:'id':'name' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="incomeAccountId">
            <th mat-header-cell *matHeaderCellDef> Income Account </th>
            <td mat-cell *matCellDef="let feesIncome">
              {{ feesIncome.incomeAccountId | find:incomeAndLiabilityAccountData:'id':'name' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let feesIncome; let i = index">
              <button mat-icon-button color="primary" (click)="edit('FeesIncome', feeToIncomeAccountMappings, i)">
                <fa-icon icon="edit"></fa-icon>
              </button>
              <button mat-icon-button color="warn" (click)="delete(feeToIncomeAccountMappings, i)">
                <fa-icon icon="trash"></fa-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="feesPenaltyIncomeDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: feesPenaltyIncomeDisplayedColumns;"></tr>

        </table>

        <h4 fxFlex="33%" class="mat-h4">Map Penalties to Specific Income Accounts</h4>

        <div fxFlex="63%">
          <button type="button" mat-raised-button color="primary" (click)="add('PenaltyIncome', penaltyToIncomeAccountMappings)">
            <fa-icon icon="plus" class="m-r-10"></fa-icon>
            Add
          </button>
        </div>


        <table fxFlex="98%" class="mat-elevation-z1" mat-table [dataSource]="penaltyToIncomeAccountMappings.value" *ngIf="penaltyToIncomeAccountMappings.value.length !== 0">

          <ng-container matColumnDef="chargeId">
            <th mat-header-cell *matHeaderCellDef> Penalty </th>
            <td mat-cell *matCellDef="let penaltyIncome">
              {{ (penaltyIncome.chargeId | find:penaltyData:'id':'name') || "❗️⚠️💀INACTIVE CHARGE❗️⚠️💀" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="assetAccountId">
            <th mat-header-cell *matHeaderCellDef> Asset Account </th>
            <td mat-cell *matCellDef="let penaltyIncome">
              {{ penaltyIncome.assetAccountId | find:assetAccountData:'id':'name' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="incomeAccountId">
            <th mat-header-cell *matHeaderCellDef> Income Account </th>
            <td mat-cell *matCellDef="let penaltyIncome">
              {{ penaltyIncome.incomeAccountId | find:incomeAccountData:'id':'name' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let penaltyIncome; let i = index">
              <button mat-icon-button color="primary" (click)="edit('PenaltyIncome', penaltyToIncomeAccountMappings, i)">
                <fa-icon icon="edit"></fa-icon>
              </button>
              <button mat-icon-button color="warn" (click)="delete(penaltyToIncomeAccountMappings, i)">
                <fa-icon icon="trash"></fa-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="feesPenaltyIncomeDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: feesPenaltyIncomeDisplayedColumns;"></tr>

        </table>

      </div>

    </div>

  </div>

  <div fxLayout="row" class="margin-t" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="2%">
    <button mat-raised-button matStepperPrevious>
      <fa-icon icon="arrow-left" class="m-r-10"></fa-icon>
      Previous
    </button>
    <button mat-raised-button matStepperNext [disabled]="!loanProductFormValid">
      Next&nbsp;&nbsp;
      <fa-icon icon="arrow-right"></fa-icon>
    </button>
  </div>

</form>
